import { useCallback } from "react";
import { useAPIAction, UserAccountApi } from "melco-shared-logic";
import { ExtendTrialActionButtonInterface } from "../../components/users/ExtendTrialActionButton";

export const useExtendTrial = (userIdToExtendTrial?: string) => {
  const [ExtendTrial] = useAPIAction(
    UserAccountApi,
    async (api, ExtendTrialActionDetails: ExtendTrialActionButtonInterface) => {
      await api.subscriptionExtendTrial({
        productCode: ExtendTrialActionDetails.product_code,
        //subscriptionCode: ExtendTrialActionDetails.subscription_code,
        versionNumber: ExtendTrialActionDetails.product_version_number,
        melcoModelsExtendTrialRequest: {
          new_trial_date: ExtendTrialActionDetails.extendTrialDateTime,
        },
      });

      return {
        successMessages: [{ message: "default" }],
      };
    },
    {
      defaultApiConfigOptions: { impersonationForId: userIdToExtendTrial },
      translationPrefix: "users.tabs.trials.actions.extendtrial",
    }
  );

  return useCallback(
    async (ExtendTrialActionDetails: ExtendTrialActionButtonInterface) => {
      try {
        await ExtendTrial(ExtendTrialActionDetails);
      } catch (e) {
        console.log(e);
      }
      return true;
    },
    [ExtendTrial]
  );
};
